export default __webpack_public_path__ + "static/Sequel-100-Wide-45-43bb2cb8646ffb0f3268a58fb66cad3a.ttf";